module.exports = __webpack_public_path__ + "static/media/860c3ec7bbc5da3e97233ccecafe512e.95aaa02e.svg";